/* eslint-disable array-callback-return */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable default-case */
import _ from "lodash";
import React, {useEffect, useState} from "react";
import {useDispatch} from "react-redux";
import {Accordion, Button, Card, Form, Table} from "react-bootstrap";
import {Get, Post} from "../../lib/Request";
import {ConsoleLog} from "../../lib/ConsoleHelper";
import {
  API_CONSOLIDATION_ROLE_SCORES,
  API_CONSOLIDATION_SCORES,
  API_POST_CONSOLIDATION_EMPLOYEE_ROLE_LEVEL_UPDATE,
  API_POST_CONSOLIDATION_UPDATE_MANUAL_SCORE,
} from "../../const/Api";
import {ALERT_VARIANT, QUESTION_TYPE, ScoreRanges} from "../../const/dataEnum";
import {setAlert} from "../../stores/actions/alertModalStateAction";
import LoadingComponent from "../../components/LoadingComponent";
import PeriodDropdown from "../../components/CommonDropdown/PeriodDropdown";
import DepartmentDropdown from "../../components/CommonDropdown/DepartmentDropdown";
import PracticeDropdown from "../../components/CommonDropdown/PracticeDropdown";

class PracticeRoleScorings {
  constructor(practiceRoleArr) {
    this.practiceRoles = practiceRoleArr;
  }

  FindRole(scoreCategory, score) {
    let minScores = Object.keys(this.practiceRoles[scoreCategory]).sort((a, b) =>
      parseFloat(a) < parseFloat(b) ? 1 : -1
    );

    let calculatedRoleKey = minScores[minScores.length - 1]; // set at lowest

    for (const minScoreIndex in minScores) {
      if (minScores[minScoreIndex] > score) continue;

      calculatedRoleKey = minScores[minScoreIndex];
      this.practiceRoles[scoreCategory][calculatedRoleKey].key = calculatedRoleKey;
      break;
    }

    return this.practiceRoles[scoreCategory][calculatedRoleKey];
  }

  GetRoleId(scoreCategory, score) {
    return this.FindRole(scoreCategory, score).id;
  }

  GetRoleString(scoreCategory, score) {
    let role = this.FindRole(scoreCategory, score);
    return `${role.roleLevelName} (>=${role.key})`;
  }
}

let practiceRoleScorings = null;

export default function Scoring() {
  const dispatch = useDispatch();

  const [periodId, setPeriodId] = useState(null);
  const [selectedDepartment, setSelectedDepartment] = useState(null);
  const [selectedPractice, setSelectedPractice] = useState(null);

  const [loadingScore, setLoadingScore] = useState(false);
  const [scoreData, setScoreData] = useState([]);

  const [practiceRole, setPracticeRole] = useState([]);

  const [selectedConsolidationStatus, setSelectedConsolidationStatus] = useState("All");

  useEffect(() => {
    if (periodId && selectedPractice?.id) generateTable(periodId, selectedPractice, selectedConsolidationStatus);
  }, [periodId, selectedPractice, selectedConsolidationStatus]);

  function ifErrorShowMessage(result) {
    if (result.responseCode < -1) {
      dispatch(setAlert({show: true, variant: ALERT_VARIANT.ERROR, message: result.message}));
    }
  }

  async function fetchRoleScores(periodID, selectedPractice) {
    let result = await Get(API_CONSOLIDATION_ROLE_SCORES + `/${selectedPractice.id}/${periodID}/`);
    ifErrorShowMessage(result);

    practiceRoleScorings = new PracticeRoleScorings(result.data[0]);

    // extract practice roles
    let gatheredPracticeRoles = [];
    Object.values(result.data[0]).forEach((v) => Object.values(v).forEach((r) => (gatheredPracticeRoles[r.id] = r)));
    gatheredPracticeRoles = gatheredPracticeRoles.sort().filter((i) => i);

    setPracticeRole(gatheredPracticeRoles);
  }

  function getPracticeRoleById(id) {
    let theRole = null;
    practiceRole.forEach((p) => {
      if (p.id !== parseInt(id)) return;

      theRole = p;
    });

    return theRole;
  }

  function getScoreRange(scoreType) {
    const scoreRange = ScoreRanges[scoreType];
    if (scoreRange) {
      return scoreRange.label;
    } else {
      return 'Score not found';
    }
  }

  function updateScoreInput(scoreItemIndex, scoreCatName, scoreDetailIndex, newScore) {
    if (newScore.length === 0) newScore = "0";

    let newParsedScore = parseFloat(newScore);

    switch (scoreData[scoreItemIndex].scores[scoreCatName].detail[scoreDetailIndex].roleScoreItem.scoreType) {
      case QUESTION_TYPE.SCORE_20:
        if (newParsedScore < 0 || newParsedScore > 20.0) return false;
        break;

      case QUESTION_TYPE.SCORE_10:
        if (newParsedScore < 0 || newParsedScore > 10.0) return false;
        break;

      case QUESTION_TYPE.SCORE_5:
        if (newParsedScore < 0 || newParsedScore > 10.0) return false;
        break;

      case "score4":
        if (newParsedScore < 0 || newParsedScore > 4.0) return false;
        break;
    }

    if (isNaN(newParsedScore)) return false;

    if (scoreData[scoreItemIndex].scores[scoreCatName].detail[scoreDetailIndex].originalScore === undefined)
      scoreData[scoreItemIndex].scores[scoreCatName].detail[scoreDetailIndex].originalScore =
        scoreData[scoreItemIndex].scores[scoreCatName].detail[scoreDetailIndex].score;

    scoreData[scoreItemIndex].scores[scoreCatName].detail[scoreDetailIndex].score =
      newParsedScore <= 0 ? 0 : parseFloat(newScore.replace(/^0+/, ""));

    let oldScore = parseFloat(scoreData[scoreItemIndex].scores[scoreCatName].detail[scoreDetailIndex].score_prev);
    scoreData[scoreItemIndex].scores[scoreCatName].total =
      scoreData[scoreItemIndex].scores[scoreCatName].total - oldScore + newParsedScore;
    ConsoleLog("updateScoreInput");
    scoreData[scoreItemIndex].scores[scoreCatName].role = practiceRoleScorings.GetRoleString(
      scoreCatName,
      scoreData[scoreItemIndex].scores[scoreCatName].total
    );
    scoreData[scoreItemIndex].scores[scoreCatName].detail[scoreDetailIndex].score_prev = newParsedScore;

    setScoreData(_.cloneDeep(scoreData));
  }

  function restoreManualSkillScore(scoreItemIndex, scoreCatName, scoreDetailIndex) {
    scoreData[scoreItemIndex].scores[scoreCatName].detail[scoreDetailIndex].score =
      scoreData[scoreItemIndex].scores[scoreCatName].detail[scoreDetailIndex].originalScore;
    setScoreData(_.cloneDeep(scoreData));
  }

  async function saveManualSkillScore(scoreItemIndex, scoreCatName, scoreDetailIndex) {
    let employeeId = scoreData[scoreItemIndex].employee.id;
    let roleScoreItemId = scoreData[scoreItemIndex].scores[scoreCatName].detail[scoreDetailIndex].roleScoreItem.id;
    let newScore = parseFloat(scoreData[scoreItemIndex].scores[scoreCatName].detail[scoreDetailIndex].score);

    if (newScore < 0) return false;

    let manualScore = {
      employeeID: employeeId,
      roleScoreItemID: roleScoreItemId,
      score: newScore,
    };

    let result = await Post(API_POST_CONSOLIDATION_UPDATE_MANUAL_SCORE, manualScore);
    ifErrorShowMessage(result);

    if (result.responseCode >= 0) {
      dispatch(setAlert({show: true, variant: ALERT_VARIANT.SUCCESS, message: "Score saved successfully"}));

      scoreData[scoreItemIndex].scores[scoreCatName].complete = true;
      scoreData[scoreItemIndex].scores[scoreCatName].detail.forEach((d, i) => {
        if (d.score < 0) {
          scoreData[scoreItemIndex].scores[scoreCatName].complete = false;
        }
      });

      setScoreData(_.cloneDeep(scoreData));
    }

    scoreData[scoreItemIndex].complete = true;
    Object.entries(scoreData[scoreItemIndex].scores).forEach(([k, s], i) => {
      if (!s.complete) scoreData[scoreItemIndex].complete = false;
    });

    return true;
  }

  async function updateRole(scoreItemIndex) {
    let newEmployeeRoleLevel = {
      employeeID: scoreData[scoreItemIndex].employee.id,
      startDate: new Date(),
      roleLevelID: scoreData[scoreItemIndex].newRole,
    };

    let result = await Post(API_POST_CONSOLIDATION_EMPLOYEE_ROLE_LEVEL_UPDATE, newEmployeeRoleLevel);
    ifErrorShowMessage(result);

    if (result.responseCode >= 0) {
      scoreData[scoreItemIndex].employee.roleLevelID = scoreData[scoreItemIndex].newRole;
      let newRole = getPracticeRoleById(scoreData[scoreItemIndex].newRole);
      scoreData[scoreItemIndex].employee.roleLevel.roleLevelName = newRole.roleLevelName;
      scoreData[scoreItemIndex].oldRole = scoreData[scoreItemIndex].newRole;

      dispatch(setAlert({show: true, variant: ALERT_VARIANT.SUCCESS, message: "Role updated successfully"}));
    }
  }

  function setEmployeeNewRole(scoreItemIndex, newRoleId) {
    scoreData[scoreItemIndex].newRole = parseInt(newRoleId);
    setScoreData(_.cloneDeep(scoreData));
  }

  async function generateTable(periodID, selectedPractice, selectedConsolidationStatus) {
    setLoadingScore(true);

    let frs = fetchRoleScores(periodID, selectedPractice);
    ConsoleLog("generateTable", periodID, selectedPractice, selectedConsolidationStatus);
    let result = await Get(
      API_CONSOLIDATION_SCORES + `/${selectedPractice.id}/${periodID}/${selectedConsolidationStatus}`
    );

    ifErrorShowMessage(result);

    await frs;

    if (result.data !== null)
      result.data.forEach((employeeScoreData) => {
        let employeeScoreDataComplete = true;
        Object.entries(employeeScoreData.scores).map(([scoreCatKey, scoreCatScores]) => {
          let scoreCatComplete = true;
          let scoreCatTotal = 0;
          scoreCatScores = {detail: scoreCatScores};
          scoreCatScores.detail.forEach((scoreCatScore) => {
            scoreCatScore.score_original = scoreCatScore.score;
            if (scoreCatScore.score < 0) {
              scoreCatScore.score_prev = 0;
              scoreCatComplete = false;
              employeeScoreDataComplete = false;
            } else {
              scoreCatScore.score_prev = scoreCatScore.score;
              scoreCatTotal = scoreCatTotal + scoreCatScore.score;
            }
          });
          scoreCatScores.total = scoreCatTotal;
          scoreCatScores.role = practiceRoleScorings.GetRoleString(scoreCatKey, scoreCatTotal);
          scoreCatScores.newRole = practiceRoleScorings.GetRoleId(scoreCatKey, scoreCatTotal);
          scoreCatScores.complete = scoreCatComplete;

          employeeScoreData.oldRole = employeeScoreData.employee.roleLevelID;
          employeeScoreData.newRole = employeeScoreData.employee.roleLevelID;

          employeeScoreData.scores[scoreCatKey] = scoreCatScores;
        });
        employeeScoreData.complete = employeeScoreDataComplete;
      });
    setScoreData(result.data);

    setLoadingScore(false);
  }

  const selection = (
    <div className="row mb-4">
      <div className="col-2">
        <label className="label">Period</label>
        <PeriodDropdown
          callbackChangePeriod={(value) => {
            if (value !== null) {
              setPeriodId(value.id);
            } else {
              setPeriodId(0);
            }
          }}
        />
      </div>

      <div className="col-3">
        <label className="label">Department</label>
        <DepartmentDropdown
          callbackChangeDepartment={(value) => {
            setSelectedDepartment(value);
          }}
        />
      </div>

      <div className="col-3">
        <label className="label">Practice</label>
        <PracticeDropdown
          callbackChangePractice={(value) => {
            setSelectedPractice(value);
          }}
          department={selectedDepartment}
        />
      </div>

      <div className="col-2">
        <label htmlFor="selectConsolidationStatus" className="label">
          Consolidation Status
        </label>
        <select
          id="selectConsolidationStatus"
          className="form-select"
          aria-label="Consolidation Status"
          value={selectedConsolidationStatus}
          disabled={false}
          onChange={(e) => {
            let chosenConsolidationStatus = e.target.value;
            setSelectedConsolidationStatus(chosenConsolidationStatus);
          }}
        >
          <option key={"All"} value={"All"}>
            All
          </option>
          <option key={"Completed"} value={"Completed"}>
            Completed
          </option>
          <option key={"Incomplete"} value={"Incomplete"}>
            Incomplete
          </option>
        </select>
      </div>
    </div>
  );

  const score_table = (
    <div className="mt-4" style={{marginTop: "-25px"}}>
      {loadingScore ? (
        <div className="text-center">
          <LoadingComponent/>
        </div>
      ) : scoreData === null ? (
        "Please select your criteria"
      ) : scoreData.length === 0 ? (
        "Based on your selection criteria there are no completed consolidated reviews yet"
      ) : (
        [
          <div>
            Reviews found: {scoreData.length} item(s)
            <br/>
            <br/>
          </div>,
          scoreData.map((scoreItem, scoreItemIndex) => {
            return (
              <Card key={scoreItemIndex} className="mb-4">
                <Card.Body style={{padding: "7px"}}>
                  <Table>
                    <thead>
                    <tr>
                      <th colSpan={2}>
                        <h4>
                          {scoreItem.employee.fullName} - {scoreItem.employee.roleLevel.roleLevelName}
                        </h4>
                      </th>
                      <th
                        style={{
                          textAlign: "right",
                          verticalAlign: "top",
                          fontSize: "xx-small",
                        }}
                      >
                        #{scoreItemIndex + 1}
                      </th>
                    </tr>
                    </thead>
                    <tbody></tbody>
                  </Table>
                  {Object.entries(scoreItem.scores).map(([scoreCatName, scoreCat], scoreIndex) => {
                    return [
                      <Accordion style={{zIndex: 999}} defaultActiveKey={scoreCat.complete ? null : 0}>
                        <Accordion.Item eventKey={0}>
                          <Accordion.Header>
                            <table>
                              <tr style={{backgroundColor: "transparent"}}>
                                <td width={"175px"} style={{border: "0px"}}>
                                  {scoreCatName}
                                </td>
                                <td width={"150px"} style={{border: "0px"}}>
                                  {scoreCat.complete ? `Total score:\u00A0${scoreCat.total.toFixed(2)}` : ""}
                                </td>
                                <td style={{border: "0px"}}>
                                  {scoreCat.complete ? `Score role:\u00A0${scoreCat.role}` : " "}
                                </td>
                                <td width={"70px"} align={"right"} style={{border: "0px"}}>
                                  {scoreCat.complete ? "Complete" : "Incomplete"}
                                </td>
                              </tr>
                            </table>
                          </Accordion.Header>
                          <Accordion.Body>
                            <Table>
                              <thead>
                              <tr>
                                <th>Review Name</th>
                                <th>Score</th>
                                <th>Notes</th>
                              </tr>
                              </thead>
                              {scoreCat.detail.map((scoreDetail, scoreDetailIndex) => {
                                return (
                                  <tr>
                                    {scoreDetail.roleScoreItem.reviewType === "manual" ? (
                                      <td
                                        style={{
                                          backgroundColor: "lightyellow",
                                        }}
                                      >
                                        {scoreDetail.roleScoreItem.reviewName}
                                        &nbsp;(
                                        {getScoreRange(scoreDetail.roleScoreItem.scoreType)})
                                      </td>
                                    ) : (
                                      <td>{scoreDetail.roleScoreItem.reviewName}</td>
                                    )}
                                    {scoreDetail.roleScoreItem.reviewType === "manual" ? (
                                      <td
                                        style={{
                                          backgroundColor: "lightyellow",
                                        }}
                                      >
                                        <Form.Control
                                          style={{
                                            backgroundColor: "white",
                                            width: "75px",
                                          }}
                                          type="text"
                                          placeholder="Score"
                                          value={scoreDetail.score.toFixed(2)}
                                          readOnly={false}
                                          onChange={(e) =>
                                            updateScoreInput(
                                              scoreItemIndex,
                                              scoreCatName,
                                              scoreDetailIndex,
                                              e.target.value
                                            )
                                          }
                                        />
                                      </td>
                                    ) : (
                                      <td>
                                        <Form.Control
                                          style={{width: "75px"}}
                                          type="text"
                                          placeholder="Score"
                                          value={scoreDetail.score < 0 ? "N/A" : scoreDetail.score.toFixed(2)}
                                          readOnly={true}
                                        />
                                      </td>
                                    )}

                                    {scoreDetail.roleScoreItem.reviewType === "manual" ? (
                                      <td
                                        style={{
                                          backgroundColor: "lightyellow",
                                        }}
                                      >
                                        Manual scoring
                                      </td>
                                    ) : (
                                      <td>Consolidated score</td>
                                    )}
                                    {scoreDetail.roleScoreItem.reviewType === "manual" ? (
                                      <td
                                        style={{
                                          textAlign: "right",
                                          backgroundColor: "lightyellow",
                                        }}
                                      >
                                        <Button
                                          size="sm"
                                          type="reset"
                                          style={{width: "100px"}}
                                          onClick={() =>
                                            restoreManualSkillScore(scoreItemIndex, scoreCatName, scoreDetailIndex)
                                          }
                                          disabled={
                                            scoreDetail.originalScore === undefined ||
                                            scoreDetail.score === scoreDetail.originalScore
                                          }
                                        >
                                          Revert
                                        </Button>
                                        &nbsp;
                                        <Button
                                          size="sm"
                                          type="submit"
                                          style={{width: "100px"}}
                                          onClick={() =>
                                            saveManualSkillScore(scoreItemIndex, scoreCatName, scoreDetailIndex)
                                          }
                                          disabled={
                                            scoreDetail.originalScore === undefined ||
                                            scoreDetail.score === scoreDetail.originalScore
                                          }
                                        >
                                          Save
                                        </Button>
                                      </td>
                                    ) : (
                                      <td>&nbsp;</td>
                                    )}
                                  </tr>
                                );
                              })}
                              <tr
                                style={{
                                  filter: "brightness(75%)",
                                  fontWeight: "bold",
                                }}
                              >
                                <td>Total</td>
                                <td>
                                  <Form.Control
                                    style={{width: "75px"}}
                                    type="text"
                                    placeholder="Score"
                                    value={scoreCat.total.toFixed(2)}
                                    readOnly={true}
                                  />
                                </td>
                                <td colSpan={2}>
                                  '{scoreCatName}' score role: {scoreCat.role}
                                </td>
                              </tr>
                            </Table>
                          </Accordion.Body>
                        </Accordion.Item>
                      </Accordion>,
                    ];
                  })}
                  <Table>
                    <thead>
                    <tr>
                      <th></th>
                    </tr>

                    {scoreItem.complete ? (
                      <tr style={{filter: "brightness(95%)"}}>
                        <td style={{textAlign: "right"}}>Change employee role to</td>
                        <td width={"100px"}>
                          <select
                            style={{width: "200px"}}
                            className="form-select"
                            aria-label="Select Period"
                            value={scoreItem.newRole}
                            onChange={(e) => setEmployeeNewRole(scoreItemIndex, e.target.value)}
                          >
                            {practiceRole.map((role, index) => (
                              <option key={role.id} value={role.id}>
                                {role.roleLevelName}
                                {scoreItem.oldRole === role.id ? " (current)" : ""}
                              </option>
                            ))}
                          </select>
                        </td>
                        <td width={"100px"} style={{textAlign: "right"}}>
                          <Button
                            size="sm"
                            type="submit"
                            style={{width: "100px"}}
                            disabled={!scoreItem.complete || scoreItem.oldRole === scoreItem.newRole}
                            onClick={() => updateRole(scoreItemIndex)}
                          >
                            Update role
                          </Button>
                        </td>
                      </tr>
                    ) : (
                      <tr>
                        <th>"To update role, please complete the manual scores above"</th>
                      </tr>
                    )}
                    </thead>
                    <tbody></tbody>
                  </Table>
                </Card.Body>
              </Card>
            );
          }),
        ]
      )}
    </div>
  );

  return (
    <div className="container mb-4">
      {selection}
      {score_table}
    </div>
  );
}
